import React from 'react'
import { Link } from 'react-router-dom'
import { Table, Tag } from 'antd'
import TableHelper from '../TableHelper'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { Pagination } from 'components/Pagination'

type TokenListProps = {
  loading: boolean,
  tokens: any,
  pagination: any,

  loadTokens: (args: SearchRequest) => void
}

export default class TokenList extends TableHelper<TokenListProps> {

  static defaultProps = {
    loading: false,
    tokens: [],

    loadTokens: () => {}
  }

  tableColumns = [
    {
      title: 'UUID',
      dataIndex: 'uuid',
      key: 'uuid',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.uuid - b.uuid
    },
    {
      title: 'Project',
      dataIndex: 'refer_schema',
      key: 'refer_schema',
      sorter: (a: any, b: any) => a.refer_schema - b.refer_schema
    },
    {
      title: 'User E-mail',
      dataIndex: 'data',
      key: 'data',
      width: 200,
      render: (text: string, record: any) => {
        const expired = (record.expire - (Date.now() / 1000)) <= 0
        let email = record?.data?.email || 'UNKNOWN'

        if (!expired) {
          return (
            <Link to={`token/${record.uuid}`}>
              <Tag color="blue" style={{cursor: 'pointer'}}>{email}</Tag>
            </Link>
          )
        }

        return <Tag color="blue">{email}</Tag>
      }
    },
    {
      title: 'Expired',
      dataIndex: 'expire',
      key: 'expire',
      responsive: ['md'] as any,
      render: (text: string, record: any) => {
        const expired = (record.expire - (Date.now() / 1000)) <= 0
        return <Tag color={expired ? 'volcano' : 'green'}>{expired ? 'Yes' : 'No'}</Tag>
      }
    },
  ]

  protected load() {
    this.searchOptions = {
      search: {
        ...this.searchOptions.search,
        action_key: 'GLOBAL_LOGIN'
      },
      options: {
        ...this.searchOptions.options,
        sort: ['-id']
      }
    }

    this.props.loadTokens(this.searchOptions)
  }

  componentDidMount(): void {
    this.load()
  }

  render() {
    const { loading, pagination, tokens, loadTokens } = this.props

    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={tokens}
          onChange={(pagination: any, filters: any, sorter: any) => this.handleTableChange(pagination, sorter, loadTokens)}
        />
         <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={tokens?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadTokens)
          }
        />
      </>
    )
  }
}
